export default __webpack_public_path__ + "static/media/Personalportrait.7cbcb87a.jpg";